import React, { useContext } from "react";
import DataEditor from "../../data-editor/DataEditor";
import { DataEditorProvider } from "../../data-editor/context/DataEditorContext";
import { AppRestaurant } from "../../admin/AdminResources";
import {
    AppOffSiteAlert,
    AppOffSiteArea,
    AppOffSiteItem,
    AppOffSiteTransaction,
    AppOffSiteUnit,
} from "../OffSiteResources";
import { DataEditorResource } from "../../data-editor/types/DataEditorTypes";
import { AppContext } from "../../../context/AppContext";
import AppUserGroups from "../../../services/AppUserGroups";

const DataEditorOffSite = (props: any) => {
    const { appState } = useContext(AppContext);
    const { history, location } = props;

    let resources: DataEditorResource[];

    const adminResources = [
        new DataEditorResource(AppOffSiteItem, { isVisibleInDataEditor: true }),
        new DataEditorResource(AppOffSiteArea, { isVisibleInDataEditor: true }),
        new DataEditorResource(AppOffSiteUnit, { isVisibleInDataEditor: true }),
        new DataEditorResource(AppOffSiteTransaction, { isVisibleInDataEditor: true }),
        new DataEditorResource(AppOffSiteAlert, { isVisibleInDataEditor: true }),
        new DataEditorResource(AppRestaurant, { isVisibleInDataEditor: false }),
    ];

    const nonAdminResources: DataEditorResource[] = [];

    if (AppUserGroups.hasAdminAccess(appState.user.groups)) {
        resources = adminResources;
    } else {
        resources = nonAdminResources;
    }

    return (
        <DataEditorProvider resources={resources} location={location} history={history}>
            <DataEditor location={location} />
        </DataEditorProvider>
    );
};

export default DataEditorOffSite;
